import React from "react";
import { teamMembers } from "./teamMembers";
import TeamMember from "./teamMember";

const Team = () => {

    // extra top padding: the values section above ends on a tall card, so the
    // default p-20 let this heading arrive almost immediately when scrolling
    return (
        <div id="team" className="lg:p-20 p-6 pt-20 lg:pt-40 w-full flex flex-col gap-6">
            <div className="container mx-auto text-center">
                <h2 className="lg:text-3xl text-2xl pointer-events-none">Our Leadership Team</h2>
            </div>
            <div className="container mx-auto flex flex-row flex-wrap gap-6 justify-center items-center h-full">
                {teamMembers.map((member) => (
                    <TeamMember key={member.id} member={member}/>
                ))}
            </div>
        </div>
    )
}

export default Team;